<i18n>
{
  "fr": {
    "searchProperty": "Chercher une propiété",
    "createProperty": "Créer une propriété",
    "town": "Commune",
    "townLabel": "Commune",
    "streetLabel": "Rue",
    "street": "Rue",
    "streetNumber": "Numéro de police",
    "properties": "propriétés",
    "folderNumber": "N° dossier",
    "reset": "Réinitialiser",
    "filter": "Filtrer",
    "complianceSurveyOnly": "Enquête de conformité seule"
  }
}
</i18n>
<template>
  <form class="search w-100" @submit.prevent="handleSubmitSearch" v-on:keyup.enter="handleOnKeyEnter()">
    <b-row>
      <div class="col-sm-6 user-filter border-right">
        <div class="form-group">
          <label class="control-label" for="town">{{ $t('townLabel') }}</label>
          <multiselect
            id="town"
            v-model="search.town"
            name="town"
            :loading="loaderData"
            :options="getTowns"
            track-by="id"
            label="internalLabel"
            :custom-label="customLabel"
          />
        </div>
        <div class="form-group">
          <label class="control-label" for="folderNumber">{{ $t('folderNumber') }}</label>
          <div class="input-group">
            <input
              type="text"
              :maxlength="$MAX_255"
              v-model="search.folderNumber"
              class="form-control"
              :placeholder="$t('folderNumber')"
            />
          </div>
        </div>
        <div class="form-group">
          <label class="control-label" for="complianceSurveyOnly">{{ $t('complianceSurveyOnly') }}</label>
          <div class="input-group">
            <multiselect
              id="complianceSurveyOnly"
              v-model="search.complianceSurveyOnly"
              name="complianceSurveyOnly"
              :options="options"
              track-by="id"
              label="label"
            />
          </div>
        </div>
      </div>
      <div class="col-sm-6 user-filter border-right">
        <div class="form-group">
          <label class="control-label" for="street">{{ $t('streetLabel') }}</label>
          <div class="input-group">
            <b-form-input id="input-small" size="sm" v-model="search.street" :placeholder="$t('street')" />
          </div>
        </div>
        <div class="form-group">
          <label class="control-label" for="streetNumber">{{ $t('streetNumber') }}</label>
          <div class="input-group">
            <input
              type="text"
              :maxlength="$MAX_255"
              v-model="search.streetNumber"
              class="form-control"
              :placeholder="$t('streetNumber')"
            />
          </div>
        </div>
      </div>
    </b-row>
    <b-row class="clearfix">
      <div class="col-sm-12 text-right filter-actions">
        <button class="reset-form btn" @click="handleClickReset">
          <i class="fa fa-trash" aria-hidden="true"></i>
          {{ $t('reset') }}
        </button>
        <button type="submit" class="btn btn-primary ladda-stop" id="filter-submit" value="filter">
          <i class="fa fa-filter" aria-hidden="true"></i>
          <span>{{ $t('filter') }}</span>
        </button>
      </div>
    </b-row>
  </form>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'Search',

  data() {
    return {
      loaderData: false,
      complianceSurveyOnly: null,
      options: [
        {
          id: '',
          label: '',
        },
        {
          id: 'oui',
          label: 'OUI',
        },
        {
          id: 'non',
          label: 'NON',
        },
      ],
    };
  },

  created() {
    window.addEventListener('keypress', this.handleOnKeyEnter);
  },
  beforeDestroy() {
    window.removeEventListener('keypress', this.handleOnKeyEnter);
  },

  computed: {
    ...mapState({ search: (state) => state.refProperties.search }),
    ...mapGetters(['getTowns']),
  },
  mounted: function () {
    if (this.getTowns.length == 0) {
      this.loaderData = true;
      this.fetchTowns();
    }
  },
  methods: {
    customLabel({ internalLabel }) {
      return internalLabel.toUpperCase();
    },
    fetchTowns() {
      this.$store.dispatch('fetchTowns').then(() => (this.loaderData = false));
    },
    handleSubmitSearch() {
      this.$store.dispatch('fetchProperties');
    },
    handleClickReset() {
      this.$store.commit('initSearchForm');
    },
    handleOnKeyEnter(event) {
      /**
       *
       * if the enter key is activated,
       * then run the filter
       *
       */
      if( event.which ){
        if (event.which == 13){ 
            event.preventDefault();
            this.$store.dispatch('fetchProperties');
          }
      }
    },
  },
};
</script>

